import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { ReportCenterApiService } from './report-center-api';

@Injectable()
export class DeleteCompanyReportService extends ReportCenterApiService<any, any> {
    public requestType = {} as any;
    public responseType = {} as any;
    public endpointName = 'v1/report';
    public serviceName = 'reportCenter';

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }

    public deleteReport(companyRoleId: number, id: number): Promise<any> {
        return this._http
            .delete(this._getEndpointUrl(companyRoleId, id), { responseType: 'text' })
            .toPromise()
            .then((response) =>
                response !== undefined ? Promise.resolve(response) : Promise.reject(null)
            )
            .catch((response) => Promise.reject(response));
    }

    private _getEndpointUrl(companyRoleId: number, id: number): string {
        return `${this.endpointUrl}/${companyRoleId}/${id}`;
    }
}
